<template>
  <div
    class="fixed top-0 left-0 right-0 w-full bg-[var(--color-8)] dark:bg-transparent dark:bg-[linear-gradient(287.24deg,#1F0432_2.25%,#1D0231_93.17%)] z-50 border-b border-[#8a36c2]"
  >
    <div class="max-w-screen-xl mx-auto px-4">
      <div class="flex items-center justify-between py-2">
        <div class="flex items-center space-x-3">
          <div class="flex items-center justify-center gap-2">
            <span class="text-sm font-semibold">Official Partner of </span>
            <WrRight class="size-[12px] fill-current" />
          </div>

          <div class="flex items-center gap-4">
            <!-- Desktop -->
            <template v-if="!isMobile">
              <div
                v-for="(icon, index) in techIcons"
                :key="index"
                class="flex items-center justify-center gap-1 cursor-pointer hover:text-[var(--primary)]"
                @click="handleOpenModal(icon.alt)"
              >
                <NuxtImg
                  :src="icon.src"
                  :alt="icon.alt"
                  class="max-w-6"
                  loading="eager"
                  height="22"
                />
                <p class="text-sm">{{ icon.alt }}</p>
              </div>
            </template>

            <!-- Mobile -->
            <template v-else>
              <div class="w-20 h-5 relative">
                <transition
                  mode="out-in"
                  enter-active-class="absolute transition-opacity duration-[1000ms] ease-in-out delay-[100ms]"
                  enter-from-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="absolute transition-opacity duration-[500ms] ease-in-out"
                  leave-from-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <div
                    :key="techIcons[currentIndex].alt"
                    class="partner-link flex items-center justify-center gap-1 cursor-pointer hover:text-[var(--primary)] absolute left-0 top-0 w-full h-full"
                    @click="handleOpenModal(techIcons[currentIndex].alt)"
                  >
                    <NuxtImg
                      :src="techIcons[currentIndex].src"
                      :alt="techIcons[currentIndex].alt"
                      class="max-w-6"
                      loading="eager"
                      height="22"
                    />
                    <p class="text-sm">{{ techIcons[currentIndex].alt }}</p>
                  </div>
                </transition>
              </div>
            </template>
          </div>
        </div>

        <div class="flex items-center justify-center space-x-2 max-md:hidden">
          <ClientOnly>
            <NuxtLink
              :to="isIndia ? '/career' : '/services/maintenance-services'"
              class="font-semibold flex items-center space-x-2 text-[#f14668] dark:text-white hover:text-[var(--primary)] tracking-[0.5px]"
            >
              <span
                class="bg-[#f14668] text-white text-xs font-medium px-2 py-1 rounded-full"
              >
                New
              </span>
              <span class="text-sm">
                {{
                  isIndia
                    ? "we're hiring!"
                    : "Get maintenance and support services starting from $49"
                }}
              </span>
              <WrRight class="size-[12px] fill-current" />
            </NuxtLink>
          </ClientOnly>
        </div>
      </div>
    </div>
  </div>

  <WrOfficialPartnerModal
    class="w-full"
    :is-open="isVisible"
    @close="isVisible = false"
  />
</template>

<script setup>
import WrRight from "~/components/atoms/icons/WrRight.vue";
import WrOfficialPartnerModal from "./WrOfficialPartnerModal.vue";
const config = useRuntimeConfig();

const { isMobile } = useDevice();

import { ref, onMounted } from "vue";

const isIndia = ref(false);

onMounted(async () => {
  try {
    const res = await fetch(
      `https://api.ipdata.co?api-key=${config.public.locationApiKey}`
    );
    const json = await res.json();
    if (json.country_name === "India") {
      isIndia.value = true;
    }
  } catch (e) {
    console.error("Error fetching location:", e);
  }
});

const techIcons = [
  { src: "/images/icons/Laravel.webp", alt: "Laravel" },
  { src: "/images/icons/Vue.webp", alt: "VueJs" },
  { src: "/images/icons/nuxt.webp", alt: "NuxtJs" },
  { src: "/images/vaahcms-logo.webp", alt: "vaahcms" },
];

const currentIndex = ref(0);
const isVisible = ref(false);

onMounted(() => {
  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % techIcons.length;
  }, 2000);
});

const handleOpenModal = (linkName) => {
  if (linkName === "vaahcms") {
    window.open(
      "https://vaah.dev/cms?utm_source=webreinvent.com&utm_medium=top-menu&utm_campaign=flash",
      "_blank"
    );
  } else {
    isVisible.value = true;
  }
};
</script>
